// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen7_comp__99t4E"};